export const t = {
  ru: {
    nav: {
      home: "Главная",
      homeDropdown: [
        { label: "О нас", href: "#" },
        { label: "Контакты", href: "#" },
      ],
      online: "Онлайн-обучение",
      onlineDropdown: [
        { label: "Обучение на Поведенческого аналитика IBA", href: "#" },
        { label: "Электронные программы", href: "#" },
        { label: "Родительский тренинг", href: "#" },
        { label: "Семинары в записи", href: "#" },
        { label: "CEU", href: "#" },
        { label: "АСТ-тренинг (ТПО)", href: "#" },
        { label: "Тематические групповые супервизии", href: "#" },
      ],
      consult: "Консультации",
      resources: "Ресурсы",
      resourcesDropdown: [
        { label: "Документы", href: "#" },
        { label: "Реестр специалистов ЭП", href: "#" },
        { label: "Статьи", href: "#" },
        { label: "Фильм «История АВА»", href: "#" },
      ],
      login: "ВОЙТИ",
    },
    hero: {
      title: "О НАС",
    },
    about: {
      heading1:
        "ABASCHOOL — это пространство, в котором родители и специалисты могут получить квалифицированную поддержку в вопросах поведения и развития детей и подростков.",
      body1:
        "Это место с удобными и простыми для восприятия онлайн-программами, консультациями и семинарами в записи, которые помогли более 1.000 семьям и специалистам слышать, понимать и обучать других людей.",
      heading2: "Самые главные цели создания ABASCHOOL",
      body2:
        "Мы объясняем Законы формирования поведения простым человеческим языком, проводим личную глубокую работу с каждым студентом и объясняем теорию так, чтобы она сразу применялась на практике. Поддержка студентов — одна из сильнейших наших сторон. Самый главный ресурс — время учеников, и нам важно, чтобы оно не утекало сквозь пальцы.",
    },
    mainSpeakers: {
      heading: "Основные спикеры ABASCHOOL",
    },
    guestSpeakers: {
      heading: "Приглашённые спикеры ABASCHOOL",
    },
    studentAchievements: {
      heading:
        "Во время тренингов наши студенты научили детей/ подростков/ взрослых",
    },
    partners: {
      heading: "Партнёры",
      subheading:
        "Организации, с которыми мы тесно сотрудничаем. Каждая из них — эталон вовлеченности, ответственности и профессионализма. Именно такой подход делает счастливое будущее более ощутимым и близким.",
    },
    footer: {
      publicOffer: "Публичная оферта",
      privacy: "Политика конфиденциальности",
      consent: "Согласие на обработку персональных данных",
      registration: "Регистрация Роспатента: № 811999",
      companyName: "ООО «Прогресс»",
      legalAddress: "Юридический адрес организации:",
      address1: "624448 Свердловская обл., г. Краснотурьинск,",
      address2: "ул. Чайковского, д.5, оф.2",
      inn: "ИНН: 6617000788",
      ogrn: "ОГРН: 1036600970702",
      account: "Номер счёта 40702810416520082212",
      bank: "Наименование банка: УРАЛЬСКИЙ БАНК ПАО СБЕРБАНК",
      corrAccount: "Корреспондентский счёт: 30101810500000000674",
      bik: "БИК: 046577674",
      copyright: "2018-2026 © ABASCHOOL",
    },
  },
  en: {
    nav: {
      home: "Home",
      homeDropdown: [
        { label: "About Us", href: "#" },
        { label: "Contacts", href: "#" },
      ],
      online: "Online Learning",
      onlineDropdown: [
        { label: "IBA Behavior Analyst Training", href: "#" },
        { label: "Electronic Programs", href: "#" },
        { label: "Parent Training", href: "#" },
        { label: "Recorded Seminars", href: "#" },
        { label: "CEU", href: "#" },
        { label: "ACT Training", href: "#" },
        { label: "Thematic Group Supervisions", href: "#" },
      ],
      consult: "Consultations",
      resources: "Resources",
      resourcesDropdown: [
        { label: "Documents", href: "#" },
        { label: "EP Specialist Registry", href: "#" },
        { label: "Articles", href: "#" },
        { label: "The History of ABA (film)", href: "#" },
      ],
      login: "LOG IN",
    },
    hero: {
      title: "ABOUT US",
    },
    about: {
      heading1:
        "ABASCHOOL is a space where parents and professionals can receive qualified support on behavioral and developmental issues in children and adolescents.",
      body1:
        "This is a place with convenient and easy-to-follow online programs, consultations, and recorded seminars that have helped more than 1,000 families and professionals hear, understand, and teach others.",
      heading2: "The Main Goals Behind Creating ABASCHOOL",
      body2:
        "We explain the laws of behavior formation in plain human language, provide deep personal work with each student, and explain theory in a way that is immediately applied in practice. Student support is one of our greatest strengths. The most valuable resource is our students\u2019 time, and it matters to us that it is never wasted.",
    },
    mainSpeakers: {
      heading: "Core Speakers of ABASCHOOL",
    },
    guestSpeakers: {
      heading: "Guest Speakers of ABASCHOOL",
    },
    studentAchievements: {
      heading:
        "During our trainings, students taught children / adolescents / adults to",
    },
    partners: {
      heading: "Partners",
      subheading:
        "Organizations we collaborate closely with. Each one is a benchmark of engagement, responsibility, and professionalism. This approach makes a happy future more tangible and within reach.",
    },
    footer: {
      publicOffer: "Public Offer Agreement",
      privacy: "Privacy Policy",
      consent: "Consent to Personal Data Processing",
      registration: "Rospatent Registration: No. 811999",
      companyName: "LLC \u00abProgress\u00bb",
      legalAddress: "Legal address:",
      address1: "624448 Sverdlovsk Region, Krasnoturinsk,",
      address2: "Tchaikovsky St., 5, office 2",
      inn: "TIN: 6617000788",
      ogrn: "OGRN: 1036600970702",
      account: "Account No. 40702810416520082212",
      bank: "Bank: URAL BANK OF SBERBANK PJSC",
      corrAccount: "Correspondent account: 30101810500000000674",
      bik: "BIC: 046577674",
      copyright: "2018-2026 \u00a9 ABASCHOOL",
    },
  },
} as const;

export type Translations = (typeof t)["ru"];
